function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import FormDescription from './FormDescription';
import FormField from './FormField';
import FormGroup from './FormGroup';
import FormMessage from './FormMessage';
import FormattedLabel from './FormattedLabel';
const propTypes = {
  /** An `id` to used to associate the label and input. */
  controlId: PropTypes.string,

  /**
   * A `react-intl` message, used as the input label. The `string` variant is
   * deprecated.
   *
   * **Note: labels should always be provided for a11y. For cases where designs
   * call for non-visible labels use `labelSrOnly` in addition to a label.**
   *
   * TODO: Make this required.
   */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** Hides label while maintaining the accessibility of the form field. */
  labelSrOnly: PropTypes.bool,

  /** Prevent form errors from rendering. The `invalid` styles will still be applied. */
  hideError: PropTypes.bool,
  description: PropTypes.node
};
/**
 * Renders a `FormField` inside a `FormGroup`.
 *
 * Unknown props are passed through to the underlying `Field` component.
 *
 * @alias Form.FieldGroup
 */

function FieldGroup({
  controlId,
  label,
  labelSrOnly,
  labelClassName,
  name,
  hideError,
  fluid,
  horizontal,
  className,
  description,
  ...props
}) {
  const id = controlId || `${name || label}Field`;
  const descriptionId = description && `${id}Description`;
  return React.createElement(FormGroup, {
    controlId: id,
    label: label,
    labelSrOnly: labelSrOnly,
    labelClassName: labelClassName,
    fluid: fluid,
    horizontal: horizontal,
    className: className
  }, React.createElement(FormField, _extends({
    name: name,
    id: id,
    "aria-describedby": descriptionId
  }, props)), description && React.createElement(FormDescription, {
    id: descriptionId
  }, React.createElement(FormattedLabel, null, description)), !hideError && React.createElement(FormMessage, {
    for: name
  }));
}

FieldGroup.propTypes = propTypes;
export default FieldGroup;